import BrokenImage from '../../src/legacy/BrokenImage';
export default BrokenImage;
